import React from 'react';
import "./HomePage.css";


function WorkCard(props) {


  return (
    <>
    <div className="workCard">
      <div className="workCardContainer">
        
          <div className="workCardImgContainer">
            <img className="workCardImg" style={{borderRadius:"1.5rem"}} src={props.source} alt="hyperContentLife"/>
          </div>

          <div className="workCardContent">
            <div><h1 className="workCardHeading">{props.heading}</h1></div>
            <div><p className="workCardSubHeading">{props.subHeading}</p></div>
          </div>
      </div>
    </div>
    </>
  )
}

export default WorkCard;